import { createContext } from 'react';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { createDispatchHook, createSelectorHook } from 'react-redux';
// eslint-disable-next-line conversations/no-private-internals-import
import { channelInstances } from '../channel-instances/_internal/reducers/channelInstances';
// eslint-disable-next-line conversations/no-private-internals-import
import { genericChannels } from '../generic-channels/_internal/reducers/genericChannels';
// eslint-disable-next-line conversations/no-private-internals-import
import { assignmentStatuses } from '../thread-actions/_internal/reducers/assignmentStatuses';
// eslint-disable-next-line conversations/no-private-internals-import
import { moveStatuses } from '../thread-actions/_internal/reducers/moveStatuses';
// eslint-disable-next-line conversations/no-private-internals-import
import { spamFilteringAndBlocking } from '../thread-actions/_internal/reducers/spamFilteringAndBlocking';
// eslint-disable-next-line conversations/no-private-internals-import
import { previousMessageHistories } from '../thread-history/_internal/reducers/previousMessageHistories';
import { getCompose } from './configureDevTools';

// Reducers
const appReducer = combineReducers({
  assignmentStatuses,
  channelInstances,
  genericChannels,
  previousMessageHistories,
  moveStatuses,
  spamFilteringAndBlocking
});
export const rootReducer = (state, action) => {
  if (action.type === 'RESET_STATE') {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};
const compose = getCompose({
  name: 'Conversations - Thread Data'
});
export const store = createStore(rootReducer, compose(applyMiddleware(thunk)));
// There are issues with createContext and createDispatchHook Typings.
export const context = /*#__PURE__*/createContext({
  store
});
export const resetStore = () => {
  store.dispatch({
    type: 'RESET_STATE'
  });
};
export const useThreadDataDispatch = createDispatchHook(context);
export const useThreadDataSelector = createSelectorHook(context);